// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ORKIY","header":"styles_header__+zumg","namepage":"styles_namepage__3UH-e","tabs":"styles_tabs__wvcsr","content":"styles_content__IsvFC"};